// Regras e mensagens do onboarding (issue #239).
//
// O mínimo do nome da organização é o mesmo do RPC create_initial_organization
// (3 caracteres, após trim). As mensagens do RPC são traduzidas aqui: a
// migration public/002 já devolve os textos em português, mas o front pode
// entrar em produção antes dela — então os textos antigos, em inglês, também
// são mapeados.

export const ORG_NAME_MIN_LENGTH = 3

// Retorna a mensagem de erro do nome, ou '' quando válido.
export function validateOrgName(name) {
  const trimmed = (name || '').trim()
  if (!trimmed) return 'Informe o nome da organização.'
  if (trimmed.length < ORG_NAME_MIN_LENGTH) {
    return `O nome da organização deve ter pelo menos ${ORG_NAME_MIN_LENGTH} caracteres.`
  }
  return ''
}

export const ORG_ALREADY_MEMBER_MESSAGE =
  'Você já faz parte de uma organização e não pode criar outra. ' +
  'Quem entrou por convite de uma organização usa a organização do convite.'

export const ORG_INVITE_REQUIRED_MESSAGE =
  'Para criar uma organização é preciso um convite de acesso. ' +
  'Se você recebeu um convite de uma organização, entre por ele — não é possível criar uma organização própria.'

// [padrão (inglês antigo OU português da migration 002), mensagem exibida]
const RPC_ERROR_MAP = [
  [/user not authenticated|usuário não autenticado/i, 'Sua sessão expirou. Entre novamente para continuar.'],
  [
    /organization name must have at least|nome da organização deve ter pelo menos/i,
    `O nome da organização deve ter pelo menos ${ORG_NAME_MIN_LENGTH} caracteres.`,
  ],
  [/organization type must be|tipo da organização deve ser/i, 'Escolha o tipo da organização: empresa ou agência.'],
  [/user already has an organization|já faz parte de uma organização/i, ORG_ALREADY_MEMBER_MESSAGE],
  [/invite code required|necessário um convite de acesso/i, ORG_INVITE_REQUIRED_MESSAGE],
  [
    /invalid, expired or already used invite code|convite de acesso inválido/i,
    'Seu convite de acesso é inválido, expirou ou já foi utilizado. Peça um novo convite para criar a organização.',
  ],
]

// Converte o erro do RPC create_initial_organization em mensagem em português.
export function translateOrgError(error) {
  const raw = typeof error === 'string' ? error : error?.message || ''
  for (const [pattern, message] of RPC_ERROR_MAP) {
    if (pattern.test(raw)) return message
  }
  if (/failed to fetch|network/i.test(raw)) {
    return 'Não foi possível falar com o servidor. Verifique sua conexão e tente novamente.'
  }
  return 'Não foi possível criar a organização. Tente novamente em instantes.'
}
